import { Component } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { Api } from '../../../api';
import cx from 'classnames';
import bannerStyles from '../../../styles/home/topBlackBanner.scss';
import { handleTrack } from '../../../utils/trackActions';

const api = new Api();

interface State {
  phone: string;
  smsSent: boolean;
  isCaptchaReceived: boolean;
}

class TopBlackBanner extends Component<State> {
  constructor(props: any) {
    super(props);
    this.state = {
      phone: '',
      smsSent: false,
      isCaptchaReceived: true,
    };
  }

  public handleChange = (e: any) => {
    const val = e.target.value;
    this.setState({
      phone: val,
    });
  };

  public handleSubmit = (e: any) => {
    const { phone } = this.state;
    const captchaResponse = grecaptcha.getResponse();

    if (captchaResponse.length === 0) {
      this.setState({
        isCaptchaReceived: false,
      });
      this.handleTopCtaTrack(e, 'Error', phone);
      e.preventDefault();
      return false;
    } else {
      this.handleTopCtaTrack(e, 'Submit', phone);
      e.preventDefault();
      api.sendBlackSMS(phone, (succeed) => {
        if (succeed) {
          this.setState({
            smsSent: true,
          });
          this.handleTopCtaTrack(e, 'Success', phone);
        }
      });
      api.recordBlackSMSSheet(phone);
    }
  };

  public handleTopCtaTrack = (
    e: any,
    trackActionCategory: string,
    phone: number
  ) => {
    handleTrack({
      action: `Click_${trackActionCategory}`,
      label: `topCTA_Input_Button`,
      value: `{}phone_no :: ${phone}`,
      obj: e.target,
    });
  };

  public render() {
    const { smsSent, isCaptchaReceived } = this.state;
    return (
      <div>
        <div className={bannerStyles['CTA-desktop']}>
          <div className={cx('large-8 small-12', bannerStyles['flex-box'])}>
            <div className="large-4">
              <img
                src="https://assets1.cleartax-cdn.com/clearsave/images/1622115567_savings11.svg"
                width="75%"
                alt="Increase your savings"
              />
            </div>
            <div className="large-8 pt10 pb10">
              <img
                src="https://assets1.cleartax-cdn.com/clearsave/images/1622786735_group167901.svg"
                width="20%"
                alt="Black Logo"
              />
              <h1 className="font--white mt10">
                File ITR, invest &{' '}
                <span className={bannerStyles['text-yellow']}>
                  save upto
                  <br /> ₹46,800
                </span>{' '}
                in taxes on the go
              </h1>
              <div className="mt10 font--white">
                <span className="pr10">0% commission </span> •{' '}
                <span className="pl10">Earn upto 1.5% extra returns</span>
              </div>
              <div className="mt10" style={{ display: 'flex' }}>
                <img
                  src="https://assets1.cleartax-cdn.com/cleartax/images/1627329045_buttongoogleplay.svg"
                  width="auto"
                  height="26px"
                  className="pr10"
                  alt="Get it on Google Play"
                />
                <img
                  src="https://assets1.cleartax-cdn.com/cleartax/images/1627326769_maskgroup1.svg"
                  width="auto"
                  height="26px"
                  className="pl10"
                  alt="Download from App Store"
                />
              </div>
            </div>
          </div>
          <div className="large-4 small-12">
            <div className={bannerStyles['top-cta-form']}>
              {/* <button className={bannerStyles['btn-orange']}>
                <a
                  href="https://cleartax.in/save/plan/19?ref=save-homepage-top-cta"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <h4 className={bannerStyles['invest-btn-text']}>
                    Start investing now
                  </h4>
                </a>
              </button>
              <div className={bannerStyles['flex-box']}>
                <hr className={bannerStyles['hr']} />
                <span className={bannerStyles['text-or']}>or</span>
                <hr className={bannerStyles['hr']} />
              </div> */}
              <form onSubmit={this.handleSubmit}>
                <input
                  className={cx('mb5', bannerStyles['input-field'])}
                  required
                  pattern="^[6789]\d{9}$"
                  placeholder="Your Phone number"
                  type="tel"
                  id="phonetop"
                  name="phone"
                  minLength={10}
                  maxLength={10}
                  onChange={this.handleChange}
                  disabled={smsSent}
                />
                {/* <script
                  src="https://www.google.com/recaptcha/api.js"
                ></script> */}
                {!smsSent ? (
                  <div>
                    {/* <div
                      className={cx('g-recaptcha', bannerStyles['captcha'])}
                      id="removeCaptcha"
                      data-sitekey="6LfH9bIaAAAAAGqM9S0evAdKtk2hHSOn3qsP1Z0s"
                    ></div> */}
                    <ReCAPTCHA sitekey="6LfH9bIaAAAAAGqM9S0evAdKtk2hHSOn3qsP1Z0s" />
                    {!isCaptchaReceived ? (
                      <div className="font--red pb10 text-center">
                        please verify you are human!
                      </div>
                    ) : null}
                    <button
                      type="submit"
                      id="downloadLinkBtn"
                      className={cx('mt5', bannerStyles['btn-blue'])}
                    >
                      <h4
                        className={bannerStyles['invest-btn-text']}
                        id="downloadlink"
                      >
                        Get download link
                      </h4>
                    </button>
                  </div>
                ) : (
                  <div className={bannerStyles['btn-green']}>
                    <h4 className={bannerStyles['invest-btn-text']}>
                      Download link sent
                    </h4>
                  </div>
                )}
              </form>
              {/* <div
                className={cx(
                  'text-center text--md pt10',
                  bannerStyles['grey-font']
                )}
              >
                For android users only*
              </div> */}
            </div>
            <div
              className={cx(
                'text--sm text-right p10 font--white',
                bannerStyles['app-text']
              )}
            >
              {/* *Coming soon on App Store */}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default TopBlackBanner;



// WEBPACK FOOTER //
// ./components/homePage/experimental/topBlackBanner.tsx